import '../styles/NavigationBar.css';
import logo from '../logo.png';

import React, { Component } from 'react';
import { Navbar, Nav, Glyphicon, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

class NavigationBar extends Component {

    state = {
        show: false
    };

    handleClose = () => this.setState({ show: false });
    handleShow = () => this.setState({ show: true });

    render() {
        return (
            <div>
                <Navbar fluid>
                    <Navbar.Header>
                        <Navbar.Brand>
                            <Link className="NavigationBar-title" to="/">
                                <img src={logo} alt="logo" className="logo"/> {process.env.REACT_APP_WEBSITE_NAME}
                            </Link>
                        </Navbar.Brand>
                    </Navbar.Header>
                    <Nav className="navbar-right">
                        <LinkContainer to="/help">
                            <NavItem eventKey={2}><Glyphicon glyph="question-sign" /></NavItem>
                        </LinkContainer>
                        {/* <NavDropdown eventKey={1} title={(<Glyphicon glyph="question-sign" />)} id="basic-nav-dropdown">
                        <MenuItem eventKey={1.1}>Help</MenuItem>
                    </NavDropdown> */}
                    </Nav>
                </Navbar>
                <Modal bsSize="large" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Help</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingOne" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <h4 className="panel-title">
                                        <span>Home Screen</span>
                                    </h4>
                                </div>
                                <div id="collapseOne" className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>Callflow Data Service is a custom web-based application that extends Genesys Cloud functionality. It provides a user friendly interface for managing CSV files. The application lists the CSV files uploaded and provides the option for downloading and deleting the files.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Home.png" alt="Home" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingTwo" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <h4 className="panel-title">
                                        <span>Upload New file</span>
                                    </h4>
                                </div>
                                <div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The Upload button highlighted in the below image, when clicked opens the window for selecting a new file. Select a file – only csv format and click OK.
                                                </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_NewFile.png" alt="Upload_NewFile" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingThree" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <h4 className="panel-title">
                                        <span>Upload InProgress</span>
                                    </h4>
                                </div>
                                <div id="collapseThree" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>
                                                    Once the file is uploaded, the status of the upload will be shows as in first image. After the file is uploaded, the file will be processed. While the files is being processed, the file is not available for download or delete as shown in second image.
                                                </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_InProgress.png" alt="Upload_InProgress" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingFour" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <h4 className="panel-title">
                                        <span>Upload Complete</span>
                                    </h4>
                                </div>
                                <div id="collapseFour" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>Once the upload is complete the file is made available for download and delete and update.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Upload_Complete.png" alt="Upload_Complete" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingFive" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <h4 className="panel-title">
                                        <span>Updating file</span>
                                    </h4>
                                </div>
                                <div id="collapseFive" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFive">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The contents of a uploaded file is updated through the unique upload option provided for each files. The contents are updated and the file is uploaded using the corresponding upload button provided for the file. The upload button is in the same row of the file. </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Update_File.png" alt="Update_NewFile" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingSix" data-toggle="collapse" data-parent="#accordion" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <h4 className="panel-title">
                                        <span>Delete file</span>
                                    </h4>
                                </div>
                                <div id="collapseSix" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSix">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The files uploaded are provided with the option to delete. Only one file can be deleted at a time. Each file is deleted using the delete button in the corresponding row. A prompt shows up asking for the confirmation from user to delete the file. </p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Delete_File.png" alt="Delete_File" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingSeven" data-toggle="collapse" data-parent="#accordion" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <h4 className="panel-title">
                                        <span>Download file</span>
                                    </h4>
                                </div>
                                <div id="collapseSeven" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeven">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col">
                                                <p>The file is downloaded by clicking the download icon in the corresponding row.</p>
                                            </div>
                                            <div className="col">
                                                <img src="../images/Download_File.png" alt="Download_File" className="helpimg help-width" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default NavigationBar;
